export default {
	login: {
		salesBackend: "Inicio de sesión en la plataforma de ventas de OMELink",
		account: "Cuenta",
		password: "Contraseña",
		login: "Iniciar sesión",
		pleaseEnter: "Por favor ingrese",
		userName: "Nombre de usuario",
		loginSuccessful: "Inicio de sesión exitoso",
		usingOa: "Inicie sesión con su cuenta OA",
		usingSjfood: "Inicie sesión con su cuenta HiFood",
	},
	index: {
		customerSettings: "Configuración del cliente",
		personalInformation: "Información personal",
		logOut: "Cerrar sesión",
		selectLanguage: "Seleccionar idioma",
		confirmExit: "¿Confirmar salida?",
		hint: "Sugerencia",
		productSettings: "Configuración del producto",
		syncSettings: "Configuración de sincronización",
		customerBinding: "Vinculación de clientes",
	},
	personal: {
		avatar: "Avatar",
		nickName: "Apodo",
	},
	operator: {
		addTo: "Agregar",
		authorizer: "Autorizador",
		permissions: "Permisos",
		startingTime: "Hora de inicio",
		endTime: "Hora de finalización",
		revise: "Modificar",
		delete: "Eliminar",
		viewPermissions: "Ver permisos, enviar permisos",
	},
	customer: {
		customerCode: "Código de cliente",
		customerName: "Nombre del cliente",
		warehouse: "Almacén",
		customerBindingQuantity: "Cantidad de clientes vinculados",
		maintenanceQuantity: "Cantidad de cambios de material mantenidos",
		operate: "Operar",
		customerBinding: "Vinculación de clientes",
		productSettings: "Configuración del producto",
		batchOpertion: "Mantenimiento por Lotes",
		selectCustomer: "Seleccionar Cliente",
		importItem: "Importar Artículo",
		batchImportItem: "Importar Artículos por Lotes",
		successfully: "Completado",
		previousStep: "Paso Anterior",
		nextStep: "Siguiente Paso",
		selectFile: "Seleccionar Archivo",
		templateDownload: "Descargar Plantilla",
		noFileSelected: "Ningún archivo seleccionado",
		downloadingTemplate: "Plantilla descargada exitosamente",
		operationSuccess: "Mantenimiento por lotes exitoso",
		aTotalOf: "Un total de",
		errorTips: "artículos tienen errores de ID detectados por el sistema, ¡importación fallida! Por favor verifique e intente nuevamente.",
		importSuccessfully: "Importación exitosa",
	},
	customerProduct: {
		myClient: "Mis clientes",
		productSettings: "Configuración de productos",
		specification: "Especificación",
		editedSuccessfully: "¡Editado correctamente!",
	},
	customerProductLastest: {
		myClient: "Mis clientes",
		productSettings: "Configuración de productos",
		syncSettings: "Configuración de sincronización",
		changeUpdates: "Verificar actualizaciones de cambios en productos",
		old: "Antiguo",
		new: "Nuevo",
		state: "Estado",
		waitingForConfirmation: "Esperando confirmación",
		applied: "Aplicado",
		notApplied: "No aplicado",
		operate: "Operar",
		newAdditions: "Nuevas adiciones",
		renew: "Renovar",
		time: "Tiempo",
		SALESConfirmed: "Confirmado por SALES",
		application: "Aplicación",
		notApplied: "No aplicar",
		successfulOperation: "¡Operación exitosa!",
	},
	customerPhone: {
		myClient: "Mis clientes",
		customerBinding: "Vinculación de clientes",
		addBinding: "Agregar vinculación",
		noData: "No hay datos disponibles, por favor añadir",
		telephoneNumber: "Número de teléfono",
		remarkName: "Nombre de referencia",
		memorandum: "Memorando",
		smsDisable: "Deshabilitar SMS",
		operate: "Operar",
		edit: "Editar",
		unbind: "Desvincular",
		CRMContact: "Por favor seleccione un contacto de CRM",
		enterANote: "Por favor ingrese una nota",
		editBinding: "Editar vinculación",
		correctPhoneNumber: "Por favor ingrese un número de teléfono válido",
		ContentIsTooLong: "Por favor, introduzca la nota",
		bindingSuccessfully: "¡Vinculación agregada exitosamente!",
		errorMessage: "¡Error al completar la información!",
		successfulOperation: "¡Operación exitosa!",
		setupSuccessful: "¡Configuración exitosa!",
		closedSuccessfully: "¡Cierre exitoso!",
		unbindHint: "¿Estás seguro de que deseas desvincular?",
		hint: "Indicación",
		UnbindingSuccessful: "¡Desvinculación exitosa!",
		numberIdentityNote: "Número, Identidad, Nota",
		selectIdentityNote: "Seleccione la nota de identidad",
		customRemarks: "Nota personalizada de identidad de número",
		pleaseEnterCustomRemarks: "Por favor, ingrese una nota personalizada de identidad de número",
		manager: "Gerente",
		boss: "Jefe",
		headChef: "Chef principal",
		accountant: "Contador",
		custom: "Personalizado",
		phoneEditDelateGuid: "No se puede operar sobre los contactos provenientes del CRM. Por favor, realice la operación en el CRM.",
        billManagement: "Gestión de factur",
        add: "Agregar",
	},
	productSpecification: {
		addTo: "Agregar",
		nameSearch: "Ingrese el nombre de la especificación para buscar",
		specificationName: "Nombre de la especificación",
		operate: "Operar",
		edit: "Editar",
		editSpecifications: "Editar especificaciones",
		attributes: "Atributos",
		addAttributes: "Por favor agregar atributos",
		name: "Nombre",
		optionName: "Por favor ingrese el nombre de la opción",
		enterSpecificationName: "¡Por favor ingrese el nombre de la especificación!",
		addOptions: "¡Por favor agregar opciones!",
		editedSuccessfully: "¡Editado con éxito!",
		errorMessage: "¡Error al completar la información!",
		enterAttributeName: "Por favor ingrese el nombre del atributo",
		sureDelete: "¿Está seguro de que desea eliminar?",
		hint: "Indicación",
		successfullyDeleted: "¡Eliminado con éxito!",
		cannotSortWhenSearching: "No se puede ordenar mientras se busca",
		sortingSaveFail: "No se puede ordenar mientras se busca",
		sortingSaveSuccess: "No se puede ordenar mientras se busca",
	},
	productHistory: {
		materialChange: "Mantenimiento de cambios de material",
		aliasSearch: "Ingrese el nombre del producto o alias para buscar",
		noData: "No hay datos disponibles",
		productName: "Nombre del producto",
		productAlias: "Alias del producto",
		category: "Categoría",
		state: "Estado",
		enable: "Habilitar",
		disable: "Deshabilitar",
		operate: "Operar",
		edit: "Editar",
		codingImportGoods: "Importar productos por código de cliente",
		importProducts: "Importar productos",
		enterCustomerCode: "Introduce el código de cliente",
		selectProduct: "Seleccionar producto",
		finish: "Finalizar",
		customerCode: "Código de cliente",
		nextStep: "Próximo paso",
		cancelSelection: "Cancelar selección",
		previous: "Anterior",
		import: "Importar",
		aTotalOf: "Se importaron con éxito un total de ",
		productImportSuccess: "productos.",
		productImportFailure: "productos como duplicados y la importación falló. Por favor verifique antes de importar.",
		pleaseEnterCustomerCode: "Por favor introduzca el código de cliente!",
		messageInformationCorrectly: "Por favor completa la información correctamente!",
		pleaseSelectProduct: "¡Seleccione la información del producto que desea importar!",
	},
	productEdit: {
		editProductInformation: "Editar información del producto",
		basicInformation: "Información básica",
		productName: "Nombre del producto",
		productAlias: "Alias del producto",
		category: "Categoría",
		state: "Estado",
		enable: "Habilitar",
		disable: "Deshabilitar",
		specificationInformation: "Información de la especificación",
		selectSpecifications: "Seleccionar especificaciones",
		deleteSpecification: "Eliminar especificación",
		enterSpecificationName: "Ingrese el nombre de la especificación",
		addSpecs: "Agregar especificaciones",
		pleaseChoose: "Por favor elegir",
		attributes: "Atributos",
	},
	productAll: {
		aliasSearch: "Ingrese el nombre del producto o alias para buscar",
		noData: "No hay datos disponibles",
		productName: "Nombre del producto",
		productAlias: "Alias del producto",
		category: "Categoría",
		state: "Estado",
		enable: "Habilitar",
		disable: "Deshabilitar",
		operate: "Operar",
		edit: "Editar",
		insert: "Insertar",
		insertingSuccessfully: "¡Insertando history exitosamente!",
	},
	avatar: {
		setAvatar: "Establecer avatar",
		preview: "Vista previa",
		changePicture: "Cambiar imagen",
		enlarge: "Ampliar",
		zoomOut: "Alejar",
		rotateLeft: "Rotar a la izquierda",
		rotateRight: "Rotar a la derecha",
		upload: "Subir",
		errorGetAvatar: "Error al obtener el avatar, por favor inténtelo de nuevo más tarde",
		sizeCannotExceed: "¡El tamaño de la imagen del avatar no puede exceder los 2MB!",
		selectPicture: "Seleccione una imagen",
		setupSuccessful: "¡Configuración exitosa!",
		uploadFailed: "Error al subir la imagen, por favor inténtelo de nuevo más tarde",
	},
	addSpecification: {
		addSpecs: "Agregar especificaciones",
		specificationName: "Nombre de la especificación",
		attributes: "Atributos",
		addAttributes: "Por favor agregue atributos",
		addTo: "Agregar",
		name: "Nombre",
		operate: "Operar",
		delete: "Eliminar",
		addProperties: "Agregar propiedades",
		enterAttributeName: "Ingrese el nombre del atributo",
		enterSpecificationName: "Ingrese el nombre de la especificación!",
		addOptions: "Por favor, agregue opciones!",
		addedSuccessfully: "¡Agregado exitosamente!",
		errorMessage: "¡La información proporcionada contiene errores!",
	},
	chatEmojiPicker: {
		recent: "Últimos usados",
		people: "Personas",
		nature: "Naturaleza",
		foods: "Comidas",
		activity: "Actividades",
		places: "Lugares",
		objects: "Objetos",
		symbols: "Símbolos",
		flags: "Banderas",
	},
	chatHistoryMessage: {
		viewContext: "Ver contexto",
		copy: "Copiar",
		save: "Guardar",
		copiedToClipboard: "Copiado al portapapeles",
		copyFailed: "Fallo al copiar",
		errorTextMessage: "Solo se admite la copia de mensajes de texto por el momento",
		errorMessage: "Solo se admite la descarga de mensajes de voz por ahora",
	},
	chatHistory: {
		enterChatContent: "Por favor, ingrese el contenido del chat",
		back: "Volver",
	},
	chatMessageCheckDetails: {
		serialNumber: "Número de serie",
		amount: "Cantidad",
		uploadDate: "Fecha de carga",
		frontPicture: "Imagen frontal del cheque",
		reversePicture: "Imagen inversa del cheque",
		supplier: "Proveedor",
		userAmount: "Entrada de cantidad por el usuario",
		checkStatus: "Estado del cheque",
	},
	chatMessageCheck: {
		checkUploadReminder: "Recordatorio de carga de cheque",
		checkCheckUpload: "Verificar carga de cheque",
		checkDetails: "Detalles del cheque",
	},
	chatMessageNonsupport: {
		versionIsTooLow: "Tu versión es demasiado baja para ver este contenido",
	},
	chatMessageOrder: {
		orderDetails: "Detalles del pedido",
		order: "Pedido",
		deliveryDate: "Fecha de entrega",
		productsOrdered: "Productos pedidos",
		productsInclude: "Productos incluyen",
		viewOrder: "Ver pedido",
	},
	chatMessageReplenishment: {
		title: "Reabastecimiento inteligente",
		deliveryDate: "Fecha de entrega",
		items: "Cantidad de ITEM",
		confirming: "Pendiente de confirmación",
		expired: "Caducado",
		confirmed: "Confirmado por {name}",
	},
	chatMessageReadStatus: {
		haveRead: "Leído",
		unread: "No leído",
		readingStatus: "Estado de lectura",
	},
	chatMessageStatus: {
		resendThisMessage: "¿Desea volver a enviar este mensaje?",
		hint: "Sugerencia",
	},
	chatMessageText: {
		translateText: "Traducir texto",
	},
	chatMessageVoice: {
		voiceIsCorrupted: "La grabación de voz está dañada",
	},
	chatMessages: {
		retractedMessage: "Ha retirado un mensaje",
		copy: "Copiar",
		save: "Guardar",
		recall: "Retirar",
		concealTranslated: "Ocultar traducción",
		translated: "Traducción",
		copiedToClipboard: "Copiado al portapapeles",
		copyFailed: "Fallo al copiar",
		supportsTextMessages: "Solo se admite la copia de mensajes de texto por el momento",
		supportsTextVoice: "Solo se admite la descarga de mensajes de voz por ahora",
		supportsTexttranslated: "Solo se admite la traducción de mensajes de texto por el momento",
	},
	chatPicturePaster: {
		sendThisImage: "¿Desea enviar esta imagen?",
		send: "Enviar",
	},
	chatRecorder: {
		recording: "Grabando",
		stop: "Detener",
		send: "Enviar",
		recordingFailed: "Error al grabar",
		timeShort: "Tiempo de grabación demasiado corto",
		timeLong: "Tiempo de grabación demasiado largo",
		microphonePermissionDenied: "La grabación falló, por favor permita el acceso al micrófono.",
	},
	contactList: {
		remarkName: "Nombre de contacto:",
	},
	contacts: {
		contactPerson: "Persona de contacto",
	},
	conversationList: {
		recentChat: "Chat reciente",
		remarkName: "Nombre de contacto:",
		cancelStick: "Cancelar fijación",
		haveRead: "Leído",
		unread: "No leído",
		stick: "Fijar",
		pinnedSuccessfully: "¡Fijado exitosamente!",
		unpinnedSuccessfully: "¡Fijación cancelada exitosamente!",
	},
	detailContact: {
		chatInformation: "Información del chat",
		METISusageCount: "Número de veces de usos de METIS：",
		leftOver: "Restantes：",
		strip: "",
		nickName: "Nombramiento",
		remarkName: "Nombre de nota",
		revise: "Modificar",
		associatedCustomers: "Cliente asociado",
		none: "Ninguno",
		smartResponse: "Respuesta inteligente de clientes por METIS",
		open: "ACTIVADO",
		close: "DESACTIVADO",
		automaticTranslation: "Traducción automática",
		setupSuccessful: "¡Configuración exitosa!",
		enterRemarks: "Ingrese el nombre de contacto",
		hint: "Consejo",
		yes: "Sí",
		no: "NO",
		phoneNumber: "Número de teléfono móvil",
		openTip1: "De las 13:30 PST a la 01:00 PST del día siguiente",
		openTip2: "Durante este período, si la intención de la pregunta del cliente se reconoce como un problema conocido, METIS responderá normalmente.",
		openTip3: "Durante este período, si la intención de la pregunta del cliente se reconoce como un problema no conocido, METIS no responderá.",
		userDoesNotBelong: "El usuario actual no es tu contacto",
	},
	detailGroup: {
		groupInformation: "Información del grupo",
		groupChatName: "Nombre del chat grupal:",
		modifyGroupName: "Modificar nombre del grupo",
		addMember: "Agregar miembro",
		noData: "No hay datos disponibles, por favor agregar",
		avatar: "Avatar",
		nickName: "Apodo",
		groupOwner: "Propietario",
		groupNotes: "Notas del grupo",
		operate: "Operar",
		editorNotes: "Editar notas",
		removeMember: "Eliminar miembro",
		userDoesNotBelong: "¡El usuario actual no pertenece a este grupo!",
		enterTheCommentName: "Ingrese el nombre del miembro",
		hint: "Consejo",
		selectMembers: "Seleccionar miembros",
		pleaseEnterTheGroupChatName: "Ingrese el nombre del chat grupal",
		groupNameHasNotChanged: "¡El nombre del grupo no ha cambiado!",
		groupNameCannotBeEmpty: "¡El nombre del grupo no puede estar vacío!",
		confirmToRemoveMember: "¿Estás seguro de que quieres eliminar este miembro?",
	},
	groupList: {
		groupChat: "Chat grupal",
		createGroupChat: "Crear chat grupal",
		groupName: "Nombre del grupo:",
	},
	selectMember: {
		selectMembers: "Seleccionar miembros",
		chosen: "Seleccionado:",
		contactPerson: "Contacto",
		salesperson: "Vendedor",
		groupChat: "de chat grupal",
		atLeast: "Se requieren al menos 3 miembros para el chat grupal",
	},
	chat: {
		realTimeServer: "La conexión al servidor en tiempo real ha fallado, intentando conectar...",
		enterSearchContent: "Ingrese el contenido de búsqueda",
		recentChat: "Chats recientes",
		addressBook: "Libreta de direcciones",
		groupChat: "Chat grupal",
		chatRecord: "Historial de chat",
		selectLanguage: "Seleccione el idioma",
		ctrlEnter: "Presione Ctrl + Enter para enviar el mensaje",
		commandEnter: "Presione Command + Enter para enviar el mensaje",
		enter: "Presione Enter para enviar el mensaje",
		translateContent: "Traducir contenido",
		send: "Enviar",
		imageUploadFailed: "Error al cargar la imagen, por favor intente nuevamente",
		onlyWithdrawMessages: "Sólo puedes retirar tus propios mensajes",
		fileError: "¡No se puede leer la información del archivo de video!",
		loadFailed: "Error al cargar, haz clic para reintentar",
		loading: "Cargando...",
		fileErrorTip:
			"Error al enviar. El formato del archivo debe ser imagen o MP4, el tamaño no debe exceder los 300MB y la duración no debe superar los 30 minutos.",
		aFile: "un archivo",
		errorTip: "La carga del archivo falló, no se puede reenviar, por favor vuelva a seleccionar el archivo para cargar.",
	},
	messageJS: {
		voice: "[Voz]",
		picture: "[Imagen]",
	},
	storeIndexJS: {
		have: "Tienes",
		unreadMessages: "mensajes sin leer",
		haveNewMessage: "Tienes un nuevo mensaje",
	},
	apiJS: {
		loginHasExpired: "La sesión ha caducado, ¿deseas iniciar sesión nuevamente?",
		hint: "Consejo",
		unknownMistake: "Error desconocido",
	},
	sessionLock: {
		idleTimeout: "Su sesión fue bloqueada por inactividad. Por favor, inicie sesión nuevamente.",
	},
	router: {
		login: "Iniciar sesión",
		customerCommunication: "Comunicación con el cliente",
		setup: "configuración",
		myClient: "Mis Cliente",
		customerBinding: "Enlace de cliente",
		productSettings: "Configuración del producto",
		syncSettings: "Configuración de sincronización",
		personalInformation: "información personal",
		authorizationSettings: "Configuración de autorización",
		messageSending: "Envío de Mensaje",
		aiEmail: "AI EMAIL设置",
		openClawManagement: "Gestión de empleados digitales",
		omelinkUserServiceMaintenance: "Mantenimiento de Usuarios de OMELINK",
	},
	dateJS: {
		today: "hoy",
	},
	common: {
		cancel: "cancelar",
		confirm: "confirmar",
		sure: "seguro",
		delete: "eliminar",
		options: "opciones",
		option: "opción",
		history: "Historial",
		all: "Todos",
		setup: "Configuración",
	},
	chatMessageOrderDetails: {
		supplier: "Proveedor",
		orderBy: "Ordenado por",
		billTo: "Facturar a",
		shipTo: "Enviar a",
		deliveryDate: "Fecha de entrega",
		comment: "Comentario",
		ordered: "Pedido",
		include: "Incluir",
		orderDetails: "Detalles del pedido",
	},
	generalization: {
		listTitle: "Lista de promociones",
		searchPlaceholder: "Buscar",
		checkOut: "Ver detalles",
		sendAgain: "Reenviar",
		send: "Enviar ahora",
		detailTitle: "Detalles de promoción ",
		isSendMessage: "Enviar el mensaje a",
	},
	messageSending: {
		title: "Clientes no registrados en OMELINK",
		customerName: "Nombre del huésped",
		customerPhone: "Teléfono del huésped",
		associatedRestaurantId: "ID del restaurante asociado",
		restaurantName: "Nombre del restaurante",
		operate: "Operación",
		historyRecord: "Registro histórico",
		sendMessage: "Enviar SMS",
		cancel: "Cancelar",
		confirm: "Confirmar envío",
		restaurantId: "ID del restaurante",
		close: "Cerrar",
		orderId: "ID de pedido",
		snedText: "Contenido enviado",
		sendTime: "Hora de envío",
		sendSuccess: "Enviado correctamente",
		isCheckedDocument: "¿Ver documento?",
		isDownLoad: "¿Descargar OMELINK?",
		sendDocument: "Enviar documento",
		true: "Sí",
		false: "No",
		check: "Ver",
	},
	aiEmail: {
		account: "Cuenta de correo",
		accountDescription: "Configure el buzón usado para recibir y procesar correos de pedidos con IA.",
		configureAccount: "Configurar correo",
		editAccount: "Editar correo",
		emailAddress: "Dirección de correo",
		emailPassword: "Contraseña de correo",
		passwordSetHint: "Ya se configuró una contraseña. Déjela vacía para conservarla.",
		accountEnabled: "Activar procesamiento de correo",
		enabled: "Activo",
		disabled: "Desactivado",
		syncError: "Error de sincronización",
		latestSync: "Última sincronización",
		noSyncTime: "No disponible",
		accountEmpty: "No hay una cuenta de correo configurada. Guarde una dirección y contraseña para comenzar.",
		emailDisabledNotice: "Esta cuenta está desactivada. Los correos no se sincronizarán ni procesarán, pero los contactos se pueden mantener.",
		contacts: "Contactos de correo",
		contactsDescription: "Solo los correos de pedido de contactos configurados serán procesados por IA.",
		addContact: "Agregar contacto",
		editContact: "Editar contacto",
		guestEmail: "Correo del cliente",
		processingMode: "Modo de procesamiento",
		automatic: "Automático",
		semiAutomatic: "Semiautomático",
		automaticDescription: "La IA responde al cliente en inglés y crea el pedido cuando la información está completa.",
		semiAutomaticDescription: "La IA identifica silenciosamente la intención de pedido y lo crea sin responder al cliente.",
		associatedCustomers: "Customers asociados",
		updatedAt: "Actualizado",
		actions: "Acciones",
		edit: "Editar",
		delete: "Eliminar",
		customerPlaceholder: "Seleccione Customers",
		noCustomers: "No hay Customer disponible para el vendedor actual.",
		loadingAccount: "Cargando la configuración de correo...",
		loadingContacts: "Cargando contactos...",
		validatingConnection: "Verificando la conexión de correo...",
		save: "Guardar",
		accountSaveSuccess: "Configuración de correo guardada.",
		statusUpdateSuccess: "Estado de correo actualizado.",
		contactCreateSuccess: "Contacto creado.",
		contactUpdateSuccess: "Contacto actualizado.",
		contactDeleteSuccess: "Contacto eliminado.",
		validationEmail: "Introduzca una dirección de correo válida.",
		validationPassword: "La contraseña es obligatoria al guardar esta cuenta por primera vez.",
		validationMode: "Seleccione un modo de procesamiento.",
		validationCustomers: "Seleccione al menos un Customer.",
		confirmDelete: "Confirmar eliminación",
		deleteContactMessage: "Después de eliminarlo, el sistema no procesará nuevos correos de {email}. ¿Eliminar este contacto?",
	},
	serviceMaintenance: {
		userList: "Lista de Usuarios",
		serviceProviderList: "Lista de Proveedores de Servicio",
		customerName: "Nombre del Huésped",
		customerPhone: "Teléfono del  Huésped",
		associatedRestaurantId: "ID del Restaurante Asociado",
		restaurantName: "Nombre del Restaurante",
		operate: "Operaciones / Acciones",
		serviceMaintenance: "Mantenimiento de Proveedores de Servicio",
		batchMaintenance: "Mantenimiento por Lotes de Proveedores de Servicio",
		sort: "Número de Secuencia / Orden",
		applicationName: "Nombre de la Aplicación",
		type: "Categoría / Tipo",
		status: "Estado",
		selectUsers: "Seleccionar Usuarios ",
		selectServiceProvider: "Seleccionar Proveedor(es) de Servicio ",
		complete: "Completar ",
		nextStep: "Siguiente Paso ",
		previous: "Paso Anterior ",
		selectServiceProviderTip: "Seleccione el(los) proveedor(es) de servicio a mostrar (los no seleccionados se configurarán como ocultos/bloqueados)",
		batchMaintenanceComplete: "Mantenimiento por Lotes Completado ",
		latestShelvesTime: "Última Hora de Puesta en Estantería/Lanzamiento ",
		introduction: "Introducción del Negocio/Descripción del Comerciante ",
		businessName: "Nombre del Negocio/Nombre del Comerciante ",
		show: "Mostrar/Exhibir ",
		hide: "Ocultar/Bloquear ",
		soft: "Software/Aplicación ",
		service: "Servicio",
		successfulOperation: "¡Operación exitosa!",
	},
	openClawManagement: {
		guestName: "Nombre del huésped",
		guestPhoneNumber: "Teléfono del huésped",
		associatedRestaurantId: "ID del restaurante asociado",
		restaurantName: "Nombre del restaurante",
		status: "Estado del empleado digital",
		operate: "Operación",
		show: "Mostrar",
		hide: "Ocultar",
		noData: "No hay datos disponibles",
		loading: "Cargando...",
		updateSuccess: "¡Operación exitosa!",
	},
};
